<div class="input-wrap select">
  <select
    class="input"
    [disabled]="isLoading"
    [(ngModel)]="value"
    (ngModelChange)="onValueChanged()"
  >
    <option [value]="''" [hidden]="required" selected="selected">
      {{ placeholder }}
    </option>
    <option
      *ngFor="let filingIndicator of claimFilingIndicators$ | async"
      [value]="filingIndicator.code"
    >
      {{ filingIndicator.code + ' - ' + filingIndicator.description }}
    </option>
  </select>
</div>
